import { Typography } from '@mui/material';
import Event from './Event';
import { event } from './Interfaces'
import React from 'react';

interface Props {
    events: event[];
    animate : boolean;
}

const EventTab: React.FC<Props> = ( { events, animate } ) => {

  if(events.length === 0) {
    return (
      <Typography variant='h5'>No event logs available.</Typography>
    )

  }

  return (
    <>
        {events.map((event,i) => 
            <Event key={i + event.dateUTC} event={event} delay={10+ i*5} animate={animate} />
        )}

    </>
  )
}

export default EventTab